module.exports = __webpack_public_path__ + "static/img/etobicoke2.5eadb82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/etobicoke2.jpg
// module id = 85
// module chunks = 9